<template>
  <nav aria-label="Navigering i footer" class="relative mb-32">
    <ul class="grid grid-cols-2 md:grid-cols-3">
      <li
        v-for="link in navLinks"
        :key="link.url + link.name"
        class="break-inside-avoid-column list-none py-10"
      >
        <NuxtLink
          :to="link.url"
          external
          class="standalone text-text-link hover:text-text-link-hover body-link-md"
        >
          {{ link.name }}
        </NuxtLink>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
const navLinks = [
  {
    name: 'Start',
    url: 'https://www.halebop.se',
  },
  {
    name: 'Mobiler',
    url: '/mobiltelefoner',
  },
  {
    name: 'Abonnemang',
    url: '/mobilabonnemang',
  },
  {
    name: 'Bredband',
    url: 'https://www.halebop.se/bredband',
  },
  {
    name: 'Erbjudanden',
    url: 'https://www.halebop.se/erbjudanden',
  },
  {
    name: 'Kontantkort',
    url: '/kontantkort',
  },
  {
    name: 'Ladda kontantkort',
    url: 'https://www.halebop.se/ladda',
  },
  {
    name: 'Ladda surf',
    url: 'https://www.halebop.se/surf',
  },
  {
    name: 'Tillbehör',
    url: '/tillbehor',
  },
  {
    name: 'Begagnat',
    url: '/begagnat',
  },
  {
    name: 'Tjänster',
    url: 'https://www.halebop.se/tjanster',
  },
  {
    name: 'Jämför mobiltelefoner',
    url: 'https://www.halebop.se/jamfor-%6Dobiltelefoner',
  },
  {
    name: 'Om Halebop',
    url: 'https://www.halebop.se/om-halebop',
  },
  {
    name: 'Senaste Nytt',
    url: 'https://www.halebop.se/senaste-nytt',
  },
  {
    name: 'Black Week',
    url: 'https://www.halebop.se/black-week',
  },
];
</script>
